// import keys from "@/utilities/i18n/translate/subscriptions/keys";
var translate = {
// translation missing for [keys.SUB_subscriptions]
// translation missing for [keys.SUB_perMonth]
// translation missing for [keys.SUB_yourActiveSub]
// translation missing for [keys.SUB_cancel]
// translation missing for [keys.SUB_upgradePremium]
// translation missing for [keys.SUB_upgrade]
// translation missing for [keys.SUB_cancelDisabledTooltip]
// translation missing for [keys.SUB_planUpdatedSuccess]
// translation missing for [SUB_reason]
// translation missing for [SUB_reasonTitle]
// translation missing for [SUB_reasonOption1]
// translation missing for [SUB_reasonOption2]
// translation missing for [SUB_reasonOption3]
// translation missing for [SUB_reasonOther]
// translation missing for [SUB_selectPlan]
// translation missing for [SUB_reasonRequired]
// translation missing for [SUB_reasonMinLength]
// translation missing for [keys.SUB_subscriptionCancellationSuccess]
// translation missing for [keys.SUB_cancelDisabledwarning]
// translation missing for [SUB_subscriptionTitle]
// translation missing for [keys.SUB_subscriptionCancellationWarning]
// translation missing for [keys.SUB_subscriptionCancellationTooltip]
// translation missing for [keys.SUB_subscriptionCancelRevokedSuccess]
// translation missing for [keys.SUB_revokeCancellation]
// translation missing for [keys.SUB_statusActive]
// translation missing for [keys.SUB_statusCancelled]
// translation missing for [keys.SUB_statusPending]
// translation missing for [keys.SUB_statusPendingDescription]
// translation missing for [keys.SUB_changePlan]
// translation missing for [keys.SUB_switchToStandard]
// translation missing for [keys.SUB_planAlreadyChangedThisMonth]
// translation missing for [keys.SUB_confirmPlanChange]
// translation missing for [keys.SUB_selectTargetPlan]
// translation missing for [keys.SUB_currentTerm]
// translation missing for [keys.SUB_cancellationWindow]
// translation missing for [keys.SUB_renewalTerm]
// translation missing for [keys.SUB_renewalTermMonths]
// translation missing for [keys.SUB_cancelDisabledCommitmentTooltip]
};
export default translate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJkZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxvRUFBb0U7QUFFcEUsSUFBTSxTQUFTLEdBQTRCO0FBQ3pDLG1EQUFtRDtBQUNuRCw4Q0FBOEM7QUFDOUMsbURBQW1EO0FBQ25ELDRDQUE0QztBQUM1QyxvREFBb0Q7QUFDcEQsNkNBQTZDO0FBQzdDLDJEQUEyRDtBQUMzRCx3REFBd0Q7QUFDeEQsdUNBQXVDO0FBQ3ZDLDRDQUE0QztBQUM1Qyw4Q0FBOEM7QUFDOUMsOENBQThDO0FBQzlDLDhDQUE4QztBQUM5Qyw0Q0FBNEM7QUFDNUMsMkNBQTJDO0FBQzNDLCtDQUErQztBQUMvQyxnREFBZ0Q7QUFDaEQscUVBQXFFO0FBQ3JFLDJEQUEyRDtBQUMzRCxrREFBa0Q7QUFDbEQscUVBQXFFO0FBQ3JFLHFFQUFxRTtBQUNyRSxzRUFBc0U7QUFDdEUsd0RBQXdEO0FBQ3hELGtEQUFrRDtBQUNsRCxxREFBcUQ7QUFDckQsbURBQW1EO0FBQ25ELDhEQUE4RDtBQUM5RCxnREFBZ0Q7QUFDaEQsc0RBQXNEO0FBQ3RELGlFQUFpRTtBQUNqRSx1REFBdUQ7QUFDdkQsc0RBQXNEO0FBQ3RELGlEQUFpRDtBQUNqRCx3REFBd0Q7QUFDeEQsaURBQWlEO0FBQ2pELHVEQUF1RDtBQUN2RCxxRUFBcUU7Q0FDdEUsQ0FBQTtBQUVELGVBQWUsU0FBUyxDQUFDIn0=